// extracted by mini-css-extract-plugin
export default {"bgEntry":"goldBackgrounds_bgEntry__R2nq8","bgCamera":"goldBackgrounds_bgCamera__7YjOe","bgFinal":"goldBackgrounds_bgFinal__HWzhq"};